import { render, staticRenderFns } from "./BasicDataDetailSetting.vue?vue&type=template&id=89cf13b6&scoped=true&"
import script from "./BasicDataDetailSetting.vue?vue&type=script&lang=js&"
export * from "./BasicDataDetailSetting.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataDetailSetting.vue?vue&type=style&index=0&id=89cf13b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cf13b6",
  null
  
)

export default component.exports